export default __webpack_public_path__ + "static/media/i55.bcc7cd41.svg";